import styled from '@emotion/styled';
import { transparentize } from 'polished';
import { Shadow } from '../../styles';

export const Picture = styled.div`
  grid-area: b;

  background-image: url(${props => props.src});
  background-color: ${props => props.theme.backgroundColor};
  background-size: cover;

  border-radius: 50%;

  ${props =>
    props.zoom
      ? `
    height: 12rem;
    width: 12rem;
  `
      : props.size && props.size === 'small'
      ? `
    margin-left: 1em;
    margin-right: 1em;
    height: 7.5rem;
    width: 7.5rem;
      `
      : `
    height: 10rem;
    width: 10rem;
  `}
`;

export const NameBlock = styled.div`
  grid-area: c;
  align-self: center;
  justify-self: start;
`;

export const Name = styled.p`
  color: ${props => props.theme.foregroundTextColor};

  height: 2.3em;

  overflow: hidden;

  font-size: 1.3rem;
  font-weight: 600;

  ${props =>
    props.size && props.size === 'small'
      ? `
    display: table-cell;
    vertical-align: middle;

    text-align: left;

    margin-left: 1rem;
    margin-right: 1rem;
    margin-top: 0;
    margin-bottom: 0.5em;
  `
      : `
    text-align: center;

    margin-left: 1rem;
    margin-right: 1rem;
    margin-top: 1em;
    margin-bottom: 0.5em;
  `}
`;

export const TextBlock = styled.div`
  grid-area: d;
  justify-self: start;
`;

export const Text = styled.p`
  color: ${props => props.theme.foregroundTextColor};

  background: linear-gradient(
    to bottom,
    ${props => props.theme.foregroundColor},
    65%,
    ${props => transparentize(0.78, props.theme.foregroundTextColor)}
  );

  ${props => Shadow(props.theme.highlightColor, '5px', 0)};

  border-radius: 20px;

  font-size: 1.2rem;
  font-weight: 600;

  ${props =>
    props.size && props.size === 'small'
      ? `
    margin-top: 0.5em;
    margin-bottom: 1em;
  `
      : null}

  padding: 0.7em 1em;

  text-align: center;
  text-transform: uppercase;
`;

export const Title = styled.h4`
  grid-area: a;

  display: grid;
  grid-template-columns: auto 1fr;

  align-items: center;
  justify-items: center;

  box-sizing: border-box;
  background: ${props => transparentize(0.6, props.theme.foregroundTextColor)};

  color: ${props => props.theme.backgroundTextColor};
  font-size: 1.4rem;

  ${props =>
    props.size && props.size === 'small'
      ? `
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  `
      : `
    margin-top: 1em;
    margin-bottom: 1em;
  `}

  padding-top: 0.3em;
  padding-bottom: 0.2em;
  padding-right: 2em;

  width: 100%;

  text-transform: uppercase;
`;

export const TextStars = styled.span`
  margin-left: 0.5em;
`;

export const TextThumbsUp = styled.span`
  margin-left: 1em;
  margin-right: 1em;
`;

export const Points = styled.span`
  font-size: 1.4rem;
`;

export const Wrapper = styled.div`
  display: grid;

  ${props =>
    props.size && props.size === 'small'
      ? `
    grid-template-areas: "a a a"
                         "b c c"
                         "b d d";
    grid-template-columns: 1fr 7fr 7fr;
    grid-template-rows: 1fr auto auto;
  `
      : `
    grid-template-areas: "a"
                         "b"
                         "c"
                         "d";
    grid-template-columns: 1fr;

    margin-top: 1.6em;
  `}

  justify-items: center;

  background-color: ${props => props.theme.foregroundColor};
  border-radius: 0.5rem;
  box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.5);

  ${props =>
    props.zoom
      ? `
    zoom: ${props.zoom};
    width: 21rem;
  `
      : props.size && props.size === 'small'
      ? `
    width: 26rem;
      `
      : `
    width: 19rem;
      `}
`;
